import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sgzp-app2forgot-password',
  templateUrl: './sgzp-app2-forgot-password.component.html',
  styleUrls: ['./sgzp-app2-forgot-password.component.css'],
})
export class SgzpApp2ForgotPasswordComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
